<script>
import {required} from "vuelidate/lib/validators"; 
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import komisyonkarari from "./komisyonkarari.vue"; 
import komisyonkararimalzeme from "./komisyonkararimalzeme.vue"; 
import moment from "moment"; 



export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Komisyon Kararı",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { 
    Loader,
    formtextarea,
    komisyonkarari,
    komisyonkararimalzeme


  },
  data() {
    return {
      title: "Komisyon Kararı",
       FormData: {},
       satdosya:{},

       Firma_Toplam:[],
       gecerli_teklifler:[],
       gecersiz_teklifler:[],
       katilanfirmalar:0,
       dosyafirmalar:[],
        OnayBelgesi:{},

       Model:{FieldName:"Ihalekomisyonkarari",
       Field:"textarea",
       FieldTitle:"Komisyon Kararı"},

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "", 
      OlcuBirimleri:[],
      excele_aktar:0,
      pdf_aktar:0,
      islem:0,
      guncelle:0,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },

      kararmetni:"",
      
    };
  },
  validations:{ 
      FormData: {  
        Ihalekomisyonkarari:{required},  
        
      }
 
  },
  methods: {

    teklifkontrol(){
        this.ActionsFilterGet({"Service":"satdosyazarfacmakontrol", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId})
        .then((ressatdosyazarfacmakontrol) => {
        
        if(ressatdosyazarfacmakontrol){

          
          this.gecersiz_teklifler=[];
          this.gecerli_teklifler=[];

          for (var j=0; j<ressatdosyazarfacmakontrol.Data.length; j++){

                  let istenenbelgeler=(JSON.parse(ressatdosyazarfacmakontrol.Data[j].Istenilenbelgeler));
                
                   // alert(Object.values(istenenbelgeler)[0])
                  let belge_kontrol=0;

                  for (var i=0; i<Object.values(istenenbelgeler).length; i++){

                    if (Object.values(istenenbelgeler)[i]>1){
                        belge_kontrol=1;
                    }
             
                  }

                  let zarffirma="";
                  for (i=0; i<this.dosyafirmalar.length;i++){

                    if (this.dosyafirmalar[i].Id==ressatdosyazarfacmakontrol.Data[j].Dosyafirmaid){
                      zarffirma=this.dosyafirmalar[i].Firmaid;
                    }

                  }


                  if (belge_kontrol==0){

                    this.gecerli_teklifler.push(zarffirma);
                   

                  } else{
                     this.gecersiz_teklifler.push(zarffirma);
                  }


          }

            this.gecerliteklifler();

        }

       });
    },

    gecerliteklifler(){

      this.ActionsFilterGet({
          Service: "SatDosyaFirma",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.satdosyaId + "&Firmaturu=3",
          }).then((ressatdosyafirma) => {

           

            this.katilanfirmalar=ressatdosyafirma.Data.length;
            this.Firma_Toplam=[];

            for (var i=0;i<ressatdosyafirma.Data.length;i++)
            {
          
              let firmaid=ressatdosyafirma.Data[i].Firmaid;
              let dosyafirmaid=ressatdosyafirma.Data[i].Id;


             var varmi=this.gecerli_teklifler.indexOf(firmaid);
           
             if (varmi>=0){

                            
              this.ActionsFilterGet({
              Service: "SatDosyaFirmaFiyat",
              Page: this.Page,
              Filter: "&Dosyaid=" + this.satdosyaId +"&Dosyafirmaid="+dosyafirmaid + "&Fiyatturu=3",
              }).then((ressatdosyafirmafiyat) => {
                  let toplam=0;
                         

                 for (var j=0; j<ressatdosyafirmafiyat.TotalCount; j++)
                 {
                    toplam=toplam+(ressatdosyafirmafiyat.Data[j].Adet*ressatdosyafirmafiyat.Data[j].Birimfiyat)
                 }   

               

                      this.ActionsGet({"Service":"OFirma/"+firmaid, "Page":this.Page}).then((firma) => {
    
                           this.Firma_Toplam.push({"firmaid":firmaid, "Firmaadi":firma.Data.Firmaadi, "toplamfiyat":toplam}) 

                           if(i==ressatdosyafirma.TotalCount){

                              this.Firma_Toplam.sort(function(a, b){return a.toplamfiyat - b.toplamfiyat});
        
                         

                           }
                         
                      });

                             
 
              }); 
            }
            }
          }); 

 
    },

     UzunTarih(value) {
        if (value) {
          var tarih=new Date(value);

          var bolunecek= moment(String(value)).format("DD.MM.YYYY.HH:DD");

          var tarihParcala=bolunecek.split(".");
          var gun = tarihParcala[0];
          var ay = tarihParcala[1]-1; //ay verisi 0-11 arasında oldugu için bir eksiği alınır.
          var yil = tarihParcala[2];
          var saat = tarihParcala[3];

          var gunler = ["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"];
          var aylar =["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
          var hangiGundeyiz = tarih.getDay();

          return gun+" "+aylar[ay]+" "+yil+" "+gunler[hangiGundeyiz]+" günü, Saat :"+saat;

        }
      },

    metnihazirla(){


        if ((this.satdosya.Ihalekomisyonkarari=="" || this.satdosya.Ihalekomisyonkarari==null) 
        && this.satdosya.Teklifdegerlendirmeyontem==1){

          this.satdosya.Ihalekomisyonkarari="İhale, ekonomik açıdan en avantajlı teklifi veren "+
          this.Firma_Toplam[0].Firmaadi+" uhdesinde kalmıştır."+
          "Komisyonumuz "+ this.UzunTarih(this.satdosya.Ihalekomisyonkararitarihi) +"’da "+
          this.OnayBelgesi.Isintanimi+" ihalesi için eksiksiz  toplanmıştır. "+
          "İhaleye 1 (bir) istekli teklif vermiştir.4734 sayılı Kamu İhale Kanunun 30 uncu maddesi uyarınca "+
          "incelenen teklif zarfları açılarak belge kontrol işlemine geçilmiştir. Yaklaşık maliyet, okunduktan "+
          "sonra teklif edilen fiyat tutanağa bağlanmış, 4734 sayılı Kamu İhale Kanunun 36 ncı maddesi uyarınca "+
          "sunulan belgeler ile teklif edilen fiyatın ayrıntılı incelenmesine geçilmiştir."+ 
          "Ayrıntılı inceleme sonucu, isteklinin belgelerinin tam ve uygun olduğu görülmüştür. "+
          this.OnayBelgesi.Isintanimi+
          " için istekli tarafından verilmiş olan teklif yukarıdaki tabloda gösterilmiştir.";

        }

  
    },

    Get() {

          this.ActionsSingleGet({
          Service: "satdosya", 
          Id: this.satdosyaId,
          }).then((res) => {
            this.satdosya = res.Data;

          });

          this.ActionsFilterGet({
          Service: "SatDosyaFirma",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.satdosyaId ,
          }).then((res) => {

              this.dosyafirmalar=res.Data;

          });


        
      this.ActionsFilterGet({"Service":"SatOnayBelgesi", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
        if (res.Data.length>0){
            this.OnayBelgesi = res.Data[0];
                 

        }
      
      });

      this.teklifkontrol();

   
    this.$emit("aktif_menu_title","Komisyon Kararı"); 


    },

    SatDosyaUpdate(){  

              if(this.satdosya.Ihalekomisyonkararitarihi!=null && this.satdosya.Ihalekomisyonkararitarihi!=""){

              this.metnihazirla();
            }
            
          this.Update("satdosya", this.satdosya);
    }



   /* ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.onaybelgesi;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      window.location.href =
        this.uri + this.base64(this.format(this.template, ctx));
    },*/
    
  },
  watch: {
    satdosyaId() { 
      this.Get();
    },

  },
  
};
</script>

<template>
<Loader>

  <div class="row">  
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body"> 
            <div class="row mb-2">

      
            <div class="col-md-12">

              <div class="row mb-2">
                <div class="col-sm-3">    
                  Satına Alınan Döküman Sayısı
                  <b-form-input 
                    v-model="satdosya.Dokumansatinalanlarinsayisi"
                    @input="SatDosyaUpdate()"        
                    type="text">
                  </b-form-input>
              </div> 
              <div class="col-sm-3">    
                Komisyon Kararı Tarihi
                  <b-form-input 
                    v-model="satdosya.Ihalekomisyonkararitarihi"
                      @input="SatDosyaUpdate()"
                    id="date" 
                    type="datetime-local"          
                  ></b-form-input>
              </div> 

            <div  class="col-sm-6">
              <div class="text-sm-end">
                <button v-if="satdosya.Teklifdegerlendirmeyontem==1"
                  type="button"
                  class="btn btn-success btn-rounded mb-2 me-2"
                  v-b-modal.komisyonkarari 
                   @click="guncelle=guncelle+1"
                >
                  <i class="mdi mdi-file-export-outline me-1"></i>
                  
                   Komisyon Kararı
                 
                </button>

                <button v-if="satdosya.Teklifdegerlendirmeyontem==2"
                  type="button"
                  class="btn btn-success btn-rounded mb-2 me-2"
                  v-b-modal.komisyonkararimalzeme 
                   @click="guncelle=guncelle+1"
                >
                  <i class="mdi mdi-file-export-outline me-1"></i>
                  
                   Komisyon Kararı
                 
                </button>


              </div>
            </div> 


            
            
            </div>

                  

         <div class="row">
            <div class="col-md-12">

                <formtextarea
                  :rows=15
                  :FormDataType= "Model"
                  :Value="satdosya.Ihalekomisyonkarari"
                  :v="$v.FormData.Ihalekomisyonkarari"
                  @input="satdosya.Ihalekomisyonkarari = $event"
                />

            </div>
            
         </div>

         
<hr>
        <button class="btn btn-primary" 
          @click="SatDosyaUpdate()" >
          {{ $t("satonaybelgesi.Page.Button1") }}
        </button>


      
                </div>

            </div> 
          
        </div>
      </div>
    </div>
  </div>

  <komisyonkarari :satdosyaId="satdosyaId" v-show="guncelle>0" :guncelle="guncelle"  />

    
  
  <komisyonkararimalzeme :satdosyaId="satdosyaId" v-show="guncelle>0" :guncelle="guncelle"  />


  </Loader>
</template>
